import { render } from "./BaseTime.vue?vue&type=template&id=36caacbc&scoped=true"
import script from "./BaseTime.vue?vue&type=script&lang=js"
export * from "./BaseTime.vue?vue&type=script&lang=js"

import "./BaseTime.vue?vue&type=style&index=0&id=36caacbc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36caacbc"]])

export default __exports__